/* globals IntersectionObserverInit */
import { RefObject, useEffect, useRef, useState } from 'react';

export function useIntersectionObserver<T extends HTMLElement>(
  options?: IntersectionObserverInit,
): [RefObject<T>, boolean] {
  const elementRef = useRef<T>(null);
  const [isVisible, setVisible] = useState(true);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(entry.isIntersecting);
    }, options);

    const node = elementRef.current;

    if (node) {
      observer.observe(node);
    }

    return (): void => {
      observer.disconnect();
    };
  }, [options]);

  return [elementRef, isVisible];
}
